import { render, staticRenderFns } from "./ModalEMDocumentNew.vue?vue&type=template&id=12476275&"
import script from "./ModalEMDocumentNew.vue?vue&type=script&lang=js&"
export * from "./ModalEMDocumentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports